export default __webpack_public_path__ + "static/media/checkmark-white.66a64f17.svg";